'use strict';

import $ from 'jquery';
import moment from 'moment';
import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import ngRollbar from 'ng-rollbar'
import uiRouter from 'angular-ui-router';
import ngMaterial from 'angular-material';
import ngFileUpload from 'ng-file-upload';
import mdDataTable from 'angular-material-data-table';

import 'angular-material-time-picker/dist/md-time-picker.css';
import mdTimePicker from 'angular-material-time-picker';

import colorPicker from './../components/canvas/colorpicker';

colorPicker($);

// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';

import { routeConfig, themeConfig, rollbarConfig } from './app.config';

import _Auth from '../components/auth/auth.module';
import _Canvas from '../components/canvas/canvas.module';
import app from './app.controller';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import slider from '../components/slider/slider.component';
import main from './main/main.component';
import configurator from './configurator/configurator.component';
import constants from './app.constants';
import util from '../components/util/util.module';

import './app.scss';

angular
  .module('komCanvasConfiguratorApp', [
    ngCookies,
    ngResource,
    ngSanitize,
    ngMessages,
    ngRollbar,
    uiRouter,
    ngMaterial,
    ngFileUpload,
    mdDataTable,
    mdTimePicker,
    _Auth,
    _Canvas,
    app,
    account,
    admin,
    navbar,
    footer,
    slider,
    main,
    configurator,
    constants,
    util
  ])
  .config(rollbarConfig)
  .config(routeConfig)
  .config(themeConfig)
  .config(function ($mdDateLocaleProvider) {
    'ngInject';

    $mdDateLocaleProvider.firstDayOfWeek = 1;
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('DD.MM.YYYY');
    };
  })
  .run(function ($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function (event, next) {
      Auth.isLoggedIn(function (loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document).ready(() => {
  angular.bootstrap(document, ['komCanvasConfiguratorApp'], {
    strictDi: true
  });
});



// WEBPACK FOOTER //
// ./client/app/app.js